import { CursorPageSchema, QueryBooleanSchema, QueryStringIntegerSchema } from 'notable-common';
import { z } from 'zod';
import { ScenarioEntitySchema } from './entity.js';
import { FingerprintOutputKindSchema } from '../fingerprint/outputKind.js';
/**
 * A UTC instant, the one shape the staff app's date filter produces, normalized the way joi
 * normalizes it so the value reaching fingerprint does not change when this schema takes over.
 */
const ScenarioQueryInstantSchema = z.iso
    .datetime()
    .transform((value) => new Date(value).toISOString());
/**
 * Every filter the scenario list offers. All optional: no filter is the full list, subject to the
 * organization scoping the controller applies on top for a non-admin user.
 */
export const ScenarioFindAllQuerySchema = z
    .object({
    name: z.string().min(1).optional(),
    nameSubstring: z.string().min(1).optional(),
    output: FingerprintOutputKindSchema.optional(),
    outputIncludes: z.string().min(1).optional(),
    providerId: z.uuid().optional(),
    practiceId: z.uuid().optional(),
    scenarioPostVisitId: z.uuid().optional(),
    populationId: z.uuid().optional(),
    limit: QueryStringIntegerSchema.optional(),
    page: QueryStringIntegerSchema.optional(),
    startTime: ScenarioQueryInstantSchema.optional(),
    organizationId: z.string().min(1).optional(),
    entity: ScenarioEntitySchema.optional(),
    isEnabled: QueryBooleanSchema.optional(),
})
    .strict();
/** The typeahead behind every scenario picker: a name fragment, scoped to one organization. */
export const ScenarioFindAllBasicQuerySchema = z
    .object({
    organizationId: z.uuid().optional(),
    q: z.string().min(1).optional(),
    limit: QueryStringIntegerSchema.optional(),
})
    .strict();
export const ScenarioListQuerySchema = ScenarioFindAllQuerySchema.pick({
    nameSubstring: true,
    entity: true,
})
    .extend({
    isEnabled: QueryBooleanSchema.optional().describe('Only scenarios that are, or are not, evaluated.'),
    organizationId: z
        .uuid()
        .optional()
        .describe('Only scenarios owned by this organization or targeting it, one of its practice groups, or one of its practices.'),
    practiceId: z
        .uuid()
        .optional()
        .describe('Only scenarios that name this practice directly. A scenario reaching it through its practice group, organization, feed, or provider is not matched.'),
    providerId: z.uuid().optional().describe('Only scenarios that name this provider directly.'),
    page: CursorPageSchema.refine((page) => !('after' in page) || z.uuid().safeParse(page.after).success, 'page.after must be a scenario ID from meta.page.after')
        .optional()
        .default({ size: 25 })
        .describe('Page size, up to 500, and the cursor returned as meta.page.after by the previous page. Defaults to the first 25.'),
})
    .strict();
//# sourceMappingURL=findAll.js.map